<template>
	<div>
		<el-card shadow="never" v-loading="formLoading">
			<el-form :inline="true" label-position="right" ref="form" :model="formData" :rules="rules" label-width="120px" size="small">
				<el-form-item label="使用状态">
					<el-radio-group v-model="type">
						<el-radio v-show="isPermit('hydropower.web.meter.basic.replace')" style="margin 10px" :label="1">停用换表</el-radio>
						<el-radio v-show="isPermit('hydropower.web.meter.basic.mothball')" style="margin 10px" :label="2">封存退费</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="截止日期">
					<el-date-picker
						style="width: 200px"
						size="small"
						v-model="formData.cutDate"
                        value-format="yyyy-MM-dd HH:mm:ss"
						type="datetime"
						:readonly="true"
						placeholder="选择日期时间"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item v-if="type == 1" label="剩余度数/吨数" prop="remainUse">
                    <el-input-number size="small" v-model="formData.remainUse" :controls="false" placeholder="剩余度数/吨数"></el-input-number>
					<div>作为新表的剩余度数/吨数</div>
				</el-form-item>
				<el-form-item label="剩余金额" prop="remainAmount">
                    <el-input-number size="small" v-model="formData.remainAmount" :controls="false" placeholder="剩余金额"></el-input-number>
					<div v-show="type == 1">作为新表的剩余金额</div>
					<div v-show="type == 2">元退还</div>
				</el-form-item>
				<el-form-item v-if="type == 1" label="新现场表号" prop="actualNo">
					<el-input style="width:200px" size="small" v-model="formData.actualNo" placeholder="新现场表号"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input
                        size="small"
                        v-model="formData.remarks"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder="请输入备注"
                    ></el-input>
				</el-form-item>
			</el-form>
			<h5 style="margin: 5px 0px 5px 100px">停用：该仪表停止使用并换用新表,旧表剩余金额和剩余度数转到新表</h5>
			<h5 style="margin: 5px 0px 5px 100px">封存：该仪表停止使用，自动退余额</h5>

			<div class="form-buttons-center">
                <el-button v-show="type == 1" size="small" type="primary" :loading="saveLoading" @click="doSaveChangeStatus" v-Jurisdiction="'hydropower.web.meter.basic.replace'">确 定</el-button>
				<el-button v-show="type == 2" size="small" type="primary" :loading="saveLoading" @click="doSaveChangeStatus" v-Jurisdiction="'hydropower.web.meter.basic.mothball'">确 定</el-button>
				<el-button size="small" @click="doClose">取 消</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import { assign, pick } from "lodash";
import dlgForm from "@/mixin/dlgForm";
export default {
	name: "ChangeStatusForm",
	mixins: [dlgForm],
	data() {
		return {
            type: this.isPermit('hydropower.web.meter.basic.replace')? 1: 2,
			rules: {
				payMeterNo: [{ required: true, message: "请输入新表号", trigger: "blur" }],
				remainUse: [
					{ type: "number", message: "必须是有效的数字", trigger: "blur" },
				],
                remainAmount: [
					{ type: "number", message: "必须是有效的数字", trigger: "blur" },
				],
			},
		};
	},
	methods: {
        getFormData() {
            if (this.type == 1) {
                const formData = assign({}, this.formData);
                formData.meterId = formData.id;
                return formData;
            }else {
                return {};
            }
        },
		doSaveChangeStatus() {
            let url;
            if (this.type == 1) {
                url = "/meter/web/basic/replace";
            } else {
                url = `/meter/web/basic/mothball/${this.formData.id}`;
            }
            this._doSaveForm(this.$refs.form, url, 'PUT');
		},
        loadFormData() {
            const url = `/meter/web/basic/${this.formData.id}`;
            const attributes = ["id", "remainUse", "remainAmount", "remarks", "actualNo"];
            this._loadFormData(url, attributes, {cutDate: new Date()});
        },
	},
	mounted() {
        this.loadFormData();
    },
};
</script>
<style scoped>
.el-input-number::v-deep .el-input__inner {
    text-align: left;
}
</style>